'use strict';

const unreadConversationIds = [
  '$rootScope',
  'userModel',
  'sounds',

  function ($rootScope, userModel, sounds) {
    var ids = [];
    var service = {
      add: function (idsToAdd) {
        idsToAdd = angular.isArray(idsToAdd) ? idsToAdd : [idsToAdd];
        idsToAdd.forEach(addId);
      },
      getIds: function () {
        return ids;
      },
      isEmpty: function () {
        return !ids.length;
      },
      remove: function (id) {
        var index = ids.indexOf(id);

        if (index > -1) {
          ids.splice(index, 1);
        }
      },
      reset: function () {
        ids.length = 0;
      }
    };

    function addId(id) {
      if (angular.isNumber(id) && ids.indexOf(id) === -1) {
        ids.push(id);
      }
    }

    $rootScope.$on('socket:unreadConversationId', (event, data) => {
      service.add(data.id);
    });

    $rootScope.$on('userModel:initialized', () => {
      service.add(userModel.item.unreadConversationsIds);
    });

    $rootScope.$on('location:update', () => {
      if (userModel.item.unreadConversationsIds && userModel.item.unreadConversationsIds.length) {
        service.add(userModel.item.unreadConversationsIds);
        sounds.playNotification();
      }
    });

    return service;
  }
];

export default unreadConversationIds;



// WEBPACK FOOTER //
// ./app/src/services/unread_conversation_ids.js